import { configureStore } from '@reduxjs/toolkit';
import { authSlice } from './auth/auth.slice';
import backendApi from './base.config';
import commonState from './common/common.slice';
import authenticationMiddleware from './middleware';

const store = configureStore({
  reducer: {
    // Add the generated reducer as a specific top-level slice
    [backendApi.reducerPath]: backendApi.reducer,
    [authSlice.name]: authSlice.reducer,
    [commonState.name]: commonState.reducer,
  },
  // Adding the api middleware enables caching, invalidation, polling,
  // and other useful features of `rtk-query`.
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }).concat(
      authenticationMiddleware,
      backendApi.middleware
    ),
});
export default store;
